export default __webpack_public_path__ + "static/media/loader-animate.69485173.svg";